<template>
  <div v-html="html"></div>
</template>
<script>
import netAPI from '@/api';
export default {
  data() {
    return {
      html: ''
    };
  },
  methods: {
    fetchVideoPay() {
      let params = {
        goodsId: this.$route.query.orderId
      };
      console.log('支付orderId', this.$route.query.orderId);
      netAPI.createSmsOrder(params).then(res => {
        console.log('支付');
        this.html = res.data.orderInfo;
        this.$nextTick(() => {
          document.forms[0].submit(); // 渲染支付宝支付页面
        });
      });
    }
  },
  mounted() {
    this.fetchVideoPay();
  }
};
</script>

<style scoped>
</style>
